import api from "@/services/api";
import { useMainStore } from "@/stores/store";
export default {
  async getCurrentUser() {
    try {
      const res = await api.get(`/api/v1/users/me`);
      const store = useMainStore();
      store.setUser(res.data);
      return res.data;
    } catch (error) {
      return null;
    }
  },

  async fetchStaff() {
    try {
      // Haal de klanten op
      const response = await api.get(`/api/v1/users-staff`);
      return response.data.data;
    } catch (error) {
      this.$toast.error(error.response.data.message);
      this.stafflist = [];
    }
  }
};
